module.exports = __webpack_public_path__ + "static/home-bd99ab3f40203fd6c12fe87995ce496c.jpeg";